import { Flex, Skeleton } from '@chakra-ui/react';

import { MOBILE_NAV_HEIGHT } from '../../core/constants/layout';
import { useIsDesktop } from '../../core/hooks/useMediaQuery';

const AppShellSkeleton = (): React.ReactElement => {
  const isDesktop = useIsDesktop();

  return (
    <Flex
      data-testid='app-shell-skeleton'
      alignItems='flex-start'
      w='100%'
      h='100vh'
      overflow='hidden'
      bgColor='whiteAlpha.solid'
    >
      {isDesktop && (
        <Flex direction='column' gap={4} w='16.5rem' h='100vh' p={4} bg='blue.950' flexShrink={0}>
          <Skeleton height='48px' borderRadius='md' />
          <Skeleton height='40px' borderRadius='md' />
          <Skeleton height='40px' borderRadius='md' />
          <Skeleton height='40px' borderRadius='md' />
        </Flex>
      )}

      <Flex direction='column' flex='1' h='100vh' overflow='hidden'>
        <Flex direction='column' px={8} py={6} gap={6} flex='1'>
          <Skeleton height='32px' width='240px' borderRadius='md' />
          <Skeleton height='20px' width='400px' borderRadius='md' />
          <Skeleton height='200px' borderRadius='md' />
        </Flex>

        {!isDesktop && (
          <Flex h={MOBILE_NAV_HEIGHT} px={6} align='center' justify='space-between' flexShrink={0}>
            <Skeleton height='32px' width='32px' borderRadius='md' />
            <Skeleton height='32px' width='32px' borderRadius='md' />
            <Skeleton height='32px' width='32px' borderRadius='md' />
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default AppShellSkeleton;
